import styles from '@components/components/Navigation/components/MetaHeader/components/MetaHeaderMobile/MetaHeaderMobile.module.scss';
import { usePageData } from '@components/context';
import React from 'react';
import { FontAwesomeProIcon, Link } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import { Tab, TabList, TabProvider } from '@ariakit/react';
import PropTypes from 'prop-types';

const MetaHeaderMobile = ({ tab }) => {
  const activeId = tab.useState('activeId');
  const { languageSwitch, metaMenu } = usePageData();
  const { isEnglishPage, link: languageLink } = languageSwitch;

  return (
    <div className={styles.container}>
      {!!metaMenu && (
        <nav aria-label="Bereiche" className={styles.areaNav}>
          <TabProvider store={tab}>
            <TabList className={styles.tabList}>
              {metaMenu.map(({ title }) => (
                <Tab
                  className={classNames(styles.tabItem, {
                    [styles.selected]: activeId === title,
                  })}
                  id={title}
                  key={`tab-${title}`}
                >
                  {title}
                </Tab>
              ))}
            </TabList>
          </TabProvider>
        </nav>
      )}
      {!!languageLink && (
        <nav aria-label="Sprache" className={styles.languageNav}>
          <ul className={styles.languageMenuList}>
            <li>
              <Link
                aria-label={
                  isEnglishPage
                    ? 'Sprache auf Deutsch ändern'
                    : 'Switch to English'
                }
                className={styles.languageSwitchLink}
                target={languageLink.target ?? '_self'}
                to={languageLink.url}
              >
                <FontAwesomeProIcon
                  className={styles.languageSwitchIcon}
                  icon="earth-europe"
                  role="presentation"
                />
                {languageLink.title}
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

MetaHeaderMobile.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tab: PropTypes.object,
};

export default MetaHeaderMobile;
